<div #manageBox class="commentary__manage d-block w-100">
  <ng-container>
    <div class="d-flex justify-content-between align-items-center mb-3">
      @if (showTitle) {
        <div class="new-select-label mb-0">
          {{ 'Commentaries.titleMany' | translate }}
        </div>
      }
      <button
        *ngIf="!hideSort && commentaries?.length"
        class="btn-icon p-0 d-inline-flex pointer"
        [matMenuTriggerFor]="menu"
      >
        <img draggable="false" src="./assets/img/sort-icon.svg" alt="sort" />
      </button>
    </div>

    <div #commentaryInp class="commentary__manage__attachments d-flex">
      <text-attachments-input
        #textAttach
        [fileName]="'files'"
        [textName]="'note'"
        [form]="form"
        23
        [config]="config"
        [attachmentsConfig]="attachmentsConfig"
      >
        <app-button
          class="mt-1"
          #content
          [loading]="loading"
          [disabled]="loading"
          (onClick)="addCommentary()"
          [config]="{
            type: ButtonTypes.NEW_SECONDARY_BLUE,
            size: ButtonSize.LARGE,
            smSize: ButtonSize.SMALL,
            text: 'Commentaries.saveCommentary' | translate
          }"
        />
      </text-attachments-input>
    </div>

    <ul class="commentary__manage__list">
      <li
        *ngFor="let commentary of commentaries; let i = index; trackBy: trackCommentaries"
        [@fadeIn]
        [@fadeOut]
      >
        <commentary-item-v2
          (commentaryEvent)="emitCommentaryEvent($event)"
          [commentary]="commentary"
          [attachmentsConfig]="attachmentsConfig"
          (commentaryEdited)="editCommentary($event, commentary)"
        />
      </li>
    </ul>
  </ng-container>
</div>

<mat-menu #menu="matMenu" xPosition="before" class="menu-v2">
  <button (click)="sortFromLatest()" mat-menu-item>
    <span>{{ 'Commentaries.fromLatest' | translate }}</span>
  </button>
  <button (click)="sortFromOldest()" mat-menu-item>
    <span>{{ 'Commentaries.fromOldest' | translate }}</span>
  </button>
</mat-menu>
